import { render } from "./TaiKhoanSelectionV2.vue?vue&type=template&id=0eb7bdab&scoped=true&ts=true"
import script from "./TaiKhoanSelectionV2.vue?vue&type=script&lang=ts"
export * from "./TaiKhoanSelectionV2.vue?vue&type=script&lang=ts"

import "./TaiKhoanSelectionV2.vue?vue&type=style&index=0&id=0eb7bdab&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb7bdab"]])

export default __exports__